import { forwardRef } from 'react'
import { HeadingProps } from './props'
import { StyledHeading } from './styles'

const Heading = forwardRef<HTMLHeadingElement, HeadingProps>(
    ({ level = 1, size, ...props }, ref) => (
        <StyledHeading
            {...props}
            as={`h${level}`}
            ref={ref}
            size={size ?? level}
        />
    )
)

Heading.displayName = 'Heading'

export default Heading

export { StyledHeading }
